import _ from 'lodash';

export const getSelectedValue = (subscriptionTypes, value) => {
  if (_.isNull(value) || _.isUndefined(value)) {
    return value;
  }

  const findSubscriptionType = subscriptionTypes.find((type) => Number(type.id) === Number(value));
  if (findSubscriptionType) {
    return {
      label: findSubscriptionType.name,
      value: findSubscriptionType.id,
    }
  }
  return null;
};
